import firebase from "firebase/app";
import "@firebase/messaging";
const firebaseConfig = {
    apiKey: "AIzaSyBEJsbXulvVwyqizbGgUdKUoYQs6tOARQE",
    authDomain: "livelet-13014.firebaseapp.com",
    projectId: "livelet-13014",
    storageBucket: "livelet-13014.appspot.com",
    messagingSenderId: "243713131785",
    appId: "1:243713131785:web:9c26b6aaa5bf3347a47fd8",
    measurementId: "G-G7BTRNSQ6J",

//    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
//    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
//    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
//    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//    appId: process.env.REACT_APP_FIREBASE_APPID,
//    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT,
};

//const firebaseConfig = {
//    apiKey: "AIzaSyCLvk3HrqIe7niuIIwFjwGNSW2n9w7pD1o",
//    authDomain: "livelet-csd.firebaseapp.com",
//    projectId: "livelet-csd",
//    storageBucket: "livelet-csd.firebasestorage.app",
//    messagingSenderId: "775670793699",
//    appId: "1:775670793699:web:70d5d6a046187232460cd6",
//    measurementId: "G-F0GQ399XML"  
//};  

firebase.initializeApp(firebaseConfig);

// export const message = firebase.messaging();

export default firebase;
